import countries from "./countries.json";

export default countries;
